import type { AiInstructionsEditRequest } from '../tunes/editorjs-ai-instructions-tune';

import {
  Button,
  DialogActionTrigger,
  DialogBody,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
  HStack,
  Text,
  Textarea,
  VStack,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { CenteredDialogContent } from '#components/ui/centered-dialog-content';

export interface AiInstructionsModalProps {
  request: AiInstructionsEditRequest | null;
  onDismiss: () => void;
}

export function AiInstructionsModal({
  request,
  onDismiss,
}: AiInstructionsModalProps) {
  const open = request != null;
  const [text, setText] = useState('');

  useEffect(() => {
    if (request) {
      setText(request.initialText);
    }
  }, [request]);

  const handleClose = () => {
    onDismiss();
  };

  const handleSave = () => {
    if (!request) return;

    const next = text.trim();
    request.onCommit(next);
    onDismiss();
  };

  return (
    <DialogRoot
      open={open}
      onOpenChange={(e) => {
        if (!e.open) handleClose();
      }}
      size="lg"
    >
      <CenteredDialogContent maxW="min(90vw, 40rem)">
        <DialogHeader>
          <DialogTitle>Block instructions for AI</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <VStack gap={3} align="stretch">
            <Text fontSize="sm" color="fg.muted">
              Optional notes for this block only. They are stored in the
              document and included when the document is sent to AI; use them to
              steer how this section should be treated.
            </Text>
            <Textarea
              value={text}
              onChange={(e) => setText(e.target.value)}
              rows={8}
              placeholder="e.g. Keep this list aligned with the board above…"
            />
          </VStack>
        </DialogBody>
        <DialogFooter>
          <HStack gap={2}>
            <DialogActionTrigger asChild>
              <Button variant="outline" onClick={handleClose}>
                Cancel
              </Button>
            </DialogActionTrigger>
            <Button onClick={handleSave}>Save</Button>
          </HStack>
        </DialogFooter>
      </CenteredDialogContent>
    </DialogRoot>
  );
}
